import { render, staticRenderFns } from "./setDistributionOrder.vue?vue&type=template&id=30892687&scoped=true&"
import script from "./setDistributionOrder.vue?vue&type=script&lang=js&"
export * from "./setDistributionOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30892687",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30892687')) {
      api.createRecord('30892687', component.options)
    } else {
      api.reload('30892687', component.options)
    }
    module.hot.accept("./setDistributionOrder.vue?vue&type=template&id=30892687&scoped=true&", function () {
      api.rerender('30892687', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/setDistributionOrder.vue"
export default component.exports